import React, {useEffect, useMemo, useState} from 'react'
import {Controller, useController, useFormContext} from 'react-hook-form'
import { ScheduleLookupOptions } from '../../../../../src/queries/useScheduleFields';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

type Props = {
  name?: string
  schedulefieldid: number | string
  label: string
  defaults: string[]
  lookupOptions: ScheduleLookupOptions[]
  setSubmitValues: Function
  submitValues: { schedulefieldid: number | string, value: {lookup: string, lookupid: number, lookupheaderid: number}[]}[]
  disabled?: boolean
  required?: boolean
}

const SelectInput = ({
  name,
  schedulefieldid,
  label,
  defaults,
  lookupOptions,
  setSubmitValues,
  submitValues,
  disabled,
  required
}: Props) => {
  const { control, formState } = useFormContext()

  const {
    field: { ref, ...inputProps }
  } = useController({
    name: schedulefieldid.toString(),
    control
  })

  const [selectedValues, setSelectedValues] = useState([])

  const getDefaults = useMemo(
      () =>
          defaults,
      [defaults, schedulefieldid]
  )

  useEffect(() => {
    if (getDefaults && getDefaults.length > 0 && selectedValues.length === 0) {
      setSelectedValues(getDefaults)
      handleChange(null, getDefaults)
    }
    return () => {
      setSelectedValues([])
    }
  }, [])

  const getOptions = () => {
    if (lookupOptions && lookupOptions.length > 0) {
      return lookupOptions
    }
    else {
      return []
    }
  }

  const handleChange = (event, values) => {
    const updatedSubmit = submitValues.filter(val => (val.schedulefieldid !== schedulefieldid))
    const vals = values.map(item => {
      if (lookupOptions && lookupOptions.length > 0) {
        return lookupOptions.filter(options => (options.lookup === item.lookup))[0]
      }
    })

    setSubmitValues([...updatedSubmit, { schedulefieldid: schedulefieldid, value: vals}])

    setSelectedValues(values)
  }

  return (
      <Controller
          control={control}
          name={name}
          rules={{ required: required ? 'Field is required' : false }}
          defaultValue={{}}
          render={({ field, fieldState: { error } }) => (
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={getOptions()}
                size={'small'}
                value={selectedValues}
                onChange={handleChange}
                disableCloseOnSelect
                getOptionLabel={(option: any) => option.lookup}
                disabled={disabled}
                renderInput={(params) => (
                    <TextField {...params} label={label} required={required} placeholder=""
                               // error={selectedValues?.length == 0} // Show error state
                               helperText={error ? error.message : null}
                    />
                )}
            />
          )}
      />
  )
}

export default SelectInput
